













































































































// @ is an alias to /src
import fileApi from "@/api/fileApi";
import qNotify from "@/common/qNotify";
import User from "@/model/user";
import store from "@/store";
import {Component, Mixins} from "vue-property-decorator";
import QErrors from "@/common/qErrors.vue";
import Authority from "@/common/mixins/authority";
import _ from "lodash";
import {compareWithKeys} from "@/common/utils";

@Component({
  name: "MyPage",
  components: {
    QErrors,
  },
})
export default class MyPage extends Mixins(Authority) {
  public userObject: User = new User();
  public userObjectInit: User = new User();
  public errors = {};
  public change = 1;
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  public defaultImage = require("@/assets/images/user-default-image.svg");

  public $refs!: {
    floorImage: HTMLFormElement
  }

  async mounted() {
    this.getUser();
    this.userObjectInit = _.cloneDeep(this.userObject)
  }

  get avatar() {
    this.change;
    return this.userObject.avatar ? this.userObject.avatar.url : this.defaultImage;
  }

  public getUser() {
    this.userObject = new User(store.state.Auth.userLogging);
  }

  public async handleFileUpload(event) {
    let file = event.target.files[0];
    if (!file) {
      return;
    }
    let formData = new FormData();
    formData.append("image", file);
    formData.append("image_type", "User");
    const result = await fileApi.uploadImage(formData);
    console.log(result);
    if (result.meta.status != 200) {
      qNotify.error({
        text: this.$t(result.meta.message),
      });
    } else {
      this.userObject.avatar = result.data;
      this.userObject.avatar_id = result.data.id;
      this.change++;
    }
  }

  public cancel() {
    if (this.isChanged()) {
      this.$modal.showCancel({
        text: this.$t("cancel"),
        // we are passing callback method for our confirm button
        onConfirm: () => {
          this.$router.back();
        },
        onClose: () => {
          console.log("onClose");
        },
      });
    } else {
      this.$router.back();
    }
  }

  public async submit() {
    const result = await this.userObject.updateMe();
    if (result.meta.status === 200) {
      qNotify.success({
        text: this.$t("me.updated"),
      });
      this.errors = {};
      // update userLoging
      store.dispatch("Auth/setUser", result.data);
    } else {
      this.errors = result.meta.errors;
      qNotify.error({
        text: result.meta.message,
      });
    }
  }

  public removeImage() {
    this.userObject.avatar_id = null;
    this.userObject.avatar = null;
    this.$refs.floorImage.value = null;
  }

  public isChanged() {
    return compareWithKeys(this.userObject, this.userObjectInit, [
      'username',
      'email',
      'avatar_id',
      'password',
    ])
  }
}
